<template>
  <footer class="footer" id="footer">
    <section id="baixar_app" v-if="GOOGLE_PLAY_URL || APP_STORE_URL" class="container-fluid">
      <div class="row flex-column align-items-center py-4 border-bottom border-top my-5 text-center">
        <h2>Baixe nosso app</h2>
        <div class="p-3 d-flex flex-column flex-md-row align-items-center">
          <a v-if="GOOGLE_PLAY_URL" :href="GOOGLE_PLAY_URL" class="m-2 t-decoration" target="_blank" rel="noopener">
            <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/cangu/landing-page/app-google.svg"
              alt="Download para Google" height="50" />
          </a>

          <a v-if="APP_STORE_URL" :href="APP_STORE_URL" class="m-2 t-decoration" target="_blank" rel="noopener">
            <img src="https://pagglo-cdn.s3.amazonaws.com/app/rede/cangu/landing-page/app-store.svg"
              alt="Download para iOS" height="50" />
          </a>
        </div>
      </div>
    </section>
    <div class="assinatura" v-if="!toogleMicroApp && !toogleFooter">
      <div class="d-flex flex-column flex-md-row justify-content-around">
        <div v-for="(categoria, index) of menu" :key="index" class="my-4">
          <h4>{{ categoria.categoria }}</h4>
          <div v-for="(item, i) of categoria.itens" :key="i">
            <router-link v-if="categoria.tipo === 'links'" :to="`/${item.arquivo}`" tag="a"
              class="btn btn-link color-config">
              {{ item.nome }}
            </router-link>
            <div class="py-1" v-else v-html="item"></div>
          </div>
        </div>
      </div>
      <br />
      © 2021 {{ nome }}, All Rights Reserved.
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      GOOGLE_PLAY_URL: window.GOOGLE_PLAY_URL,
      APP_STORE_URL: window.APP_STORE_URL,
      menu: window.FOOTER_MENU,
      nome: window.NOME || 'PAGGLO',
      logo: window.LOGO_RODAPE || '',
      redes: {
        facebook: {
          link: window.FACEBOOK,
          img: require('@/assets/images/facebook.svg'),
        },
        instagram: {
          link: window.INSTAGRAM,
          img: require('@/assets/images/instagram.svg'),
        },
        linkedin: {
          link: window.LINKEDIN,
          img: require('@/assets/images/linkedin.svg'),
        },
        twitter: {
          link: window.TWITTER,
          img: require('@/assets/images/twitter.svg'),
        },
        whatsapp: {
          link: window.WHATSAPP,
          img: require('@/assets/images/whatsapp.svg'),
        },
        youtube: {
          link: window.YOUTUBE,
          img: require('@/assets/images/youtube.svg'),
        },
      },
    }
  },
}
</script>

<style scoped lang="scss">
footer {
  bottom: 0;
  width: 100%;
  max-height: 20%;
  padding: 3rem 0 0 0;
  text-align: center;

  .color-config {
    color: var(--cor-texto);
  }

  .assinatura {
    background: var(--cor-principal);
    padding: 1rem 0;
    color: var(--cor-texto);
  }

  .contatos .contatos_redes ul {
    list-style: none;
    padding-left: 0;
  }

  .contatos .contatos_redes ul li {
    margin: 1rem;
  }

  li img {
    width: 20px;
  }

  h2 {
    color: var(--cor-principal);
    font-weight: normal;
  }
}
</style>
